export class TakeOrderModel {
    "orderLine": string = null;
    "truckId": string = null;
    "businessUnit": string = null;
    "customerAddrDescription": string = null;
    "customerAddrLine1": string = null;
    "customerAddrLine2": string = null;
    "customerAddrCity": string = null;
    "customerAddrState": string = null;
    "customerAddrZip": string = null;
    "deliveryDate": string = null;
    "deliveryTimeStart": string = null;
    "deliveryTimeEnd": string = null;
    "supplierID": string = null;
    "supplierName": string = null;
    "terminalID": string = null;
    "terminalName": string = null;
    "productCode": string = null;
    "fuelGradeCode": string = null;
    "productDescription": string = null;
    "quantityOrdered": string = null;
    "tankSerialNumber": string = null;
    "tankDescription": string = null;
    "tankSize": string = null;
    "isUndergroundTankIND": string = null;
    "needPumpIND": string = null;
    "dispatchNotes": string = null;
    "customerPO": string = null;
    "carrierOrderID": string = null;
    "fTPSCAC": string = null;
    "rackUpdateCode": string = null;
    "rackUpdateField": string = null;
    "rackUpdateValue": string = null;
    "netGallons": string = null;
    "grossGallons": string = null;
    "loadingBOL": string = null;
    "atRack": string = null;
    "leftRack": string = null;
    "liftedStartTime": string = null;
    "liftedEndTime": string = null;
    "atLocationTime": string = null;
    "leftLocationTime": string = null;
    "customField1": string = null;
    "customField2": string = null;
    "customField3": string = null;
    "customField4": string = null;
    "customField5": string = null;
    "timeZoneGMTOffset": string = null;
    "loadingNotes": string = null;
    "customerNo": string = null;
    "customerLocNo": string = null;
    "salesOrderNumber": string = null;
    "notes": string = null;
}